import { render, staticRenderFns } from "./alerta.vue?vue&type=template&id=38b427b5&"
import script from "./alerta.component.ts?vue&type=script&lang=ts&"
export * from "./alerta.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports